import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings, Info } from '../../../../../core/common';
import { IGetSampleProductOrderHeader, ISampleProductOrderHeader, ISampleProductOrderDetails, IGetSampleProductOrderDetailsByHeader } from '../../../../../core/models';
import { ProductSampleFulfillmentService } from '../../../../../core/services/product-sample-fulfillment.service';
import { UserService } from '../../../../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import { CommonService } from '../../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";

@Component({
  selector: 'app-sample-request-order-details',
  templateUrl: './sample-request-order-details.component.html',
  styleUrls: ['./sample-request-order-details.component.scss']
})
export class SampleRequestOrderDetailsComponent implements OnInit {
  orderDetailsGridData: GridDataResult;
  orderGridData: any[] = [];
  orderLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  orderNum: number = 0;
  orderHeaderGridData: ISampleProductOrderHeader;
  userEmail: string = '';

  public orderLblText = {
    orderNumberLbl: 'Order Number',
    contactLbl: 'Contact',
    customerLbl: 'Customer',
    ccEmailLbl: 'CC Email(s)',
    regionLbl: 'Region',
    createdDateLbl: 'Order Date',
    sampleProductOrderNumberLbl: 'Order Number',
    costLbl: 'Order Cost',
    trackingMethodLbl: 'Tracking Method',
    trackingNumberLbl: 'Tracking Number',
    contactEmailLbl: 'Contact Email',
  };
  public orderDetailsLblText = {
    stockNumLbl: 'Stock #',
    productDescriptionLbl: 'Product Description',
    quantityLbl: 'Quantity',
    costLbl: 'Cost',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    sampleProductLbl: 'Sample Product',
    orderSummaryLbl: 'Order Summary'
  };
  constructor(private router: Router, private route: ActivatedRoute,
    private userService: UserService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private appNotifyService: AppNotifyService, private commonService: CommonService, private cp: CurrencyPipe
  ) {
    this.route.params.subscribe((params: Params) => {
      this.orderNum = params['orderId'] || 'ttt';
      console.log(this.orderNum);
    });
  }

  ngOnInit() {
    this.orderHeaderGridData = this.productSampleFulfillmentService.getSingleOrderHeaderGridData();
    this.userEmail= this.userService.readUserObject.userEmail;
    if (this.orderHeaderGridData === undefined || this.orderHeaderGridData === null) {
      this.router.navigate(['sample-request-admin/sample-request-order-history']);
    } else {
      this.getOrderDetails();
    }
  }
  public orderGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'subCategoryDescription',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  //#region All column settings for the Grid
  public orderGridSettings: GridSettings = {
    state: this.orderGridstate,
    gridData: process(this.orderGridData, this.orderGridstate),
    columnsConfig: [{
      field: 'stockNum',
      title: this.orderDetailsLblText.stockNumLbl,
      filterable: true,
      widthForPDF: 120,
      _width: 150,
    },
    {
      field: 'subCategoryDescription',
      title: this.orderDetailsLblText.productDescriptionLbl,
      filterable: true,
      widthForPDF: 150,
      _width: 250,
    }, {
      field: 'quantity',
      title: this.orderDetailsLblText.quantityLbl,
      filterable: true,
      widthForPDF: 100,
      _width: 120,
    }
      , {
      field: 'cost',
        title: this.orderDetailsLblText.costLbl,
      filterable: true,
      widthForPDF: 100,
      _width: 150,
    }
    ]
  };

  getOrderDetails() {
    this.orderLoading = true;
    const body: IGetSampleProductOrderDetailsByHeader = {
      sampleProductUniqueId: Number(this.orderNum)
    }
    this.productSampleFulfillmentService.getSampleProductOrderDetailsByHeader(body).subscribe((response: Array<any>) => {
      if (response) {
        console.log(response);
        this.orderGridData = response;
        this.productSampleFulfillmentService.setOrderDetailsGridData(this.orderGridData);
        this.loadOrderDetailsGridData();
      }
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Soory an error occured while loading the page.');
    })
    this.orderLoading = false;
  }
  public loadOrderDetailsGridData(): void {
    if (this.orderGridSettings.state)
      this.orderDetailsGridData = process(this.orderGridData, this.orderGridSettings.state);
    else
      this.orderDetailsGridData = process(this.orderGridData, this.orderGridstate);
    this.orderGridSettings.gridData = this.orderDetailsGridData;
  }
  public orderDetailsGridSortChange(sort): void {
    this.orderGridstate.sort = sort;
    this.loadOrderDetailsGridData();
  }

  public orderDetailsGridPageChange({ skip, take }: PageChangeEvent): void {
    this.orderGridstate.skip = skip;
    this.orderGridstate.take;
    this.loadOrderDetailsGridData();
  }

  public orderDetailsGridDataStateChange(state: DataStateChangeEvent): void {
    this.orderGridstate = state;
    this.orderGridSettings.state = this.orderGridstate;
    this.loadOrderDetailsGridData();
  }
  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.orderGridSettings.state.filter;
    var filterData = process(this.orderGridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    this.orderGridSettings.columnsConfig.filter(c => c.hidden != true).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
    });
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    let worksheet = workbook.addWorksheet();
    const header = [
      this.orderDetailsLblText.stockNumLbl,
      this.orderDetailsLblText.productDescriptionLbl,
      this.orderDetailsLblText.quantityLbl,
      this.orderDetailsLblText.costLbl
    ];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([this.orderLblText.orderNumberLbl + ": " + this.orderHeaderGridData.sampleProductOrderNumber + '', '', '', '', this.orderLblText.createdDateLbl + ": " + this.orderHeaderGridData.createdDateUIString]);
    worksheet.addRow([this.orderLblText.customerLbl + ": " + this.orderHeaderGridData.customer + '', '', '', '', this.orderLblText.costLbl + ": " + (this.orderHeaderGridData.cost ? this.cp.transform(this.orderHeaderGridData.cost, 'USD', true, '1.2-2') : '')]);
    worksheet.addRow([this.orderLblText.contactLbl + ": " + this.orderHeaderGridData.contact + '', '', '', '', this.orderLblText.regionLbl + ": " + this.orderHeaderGridData.region]);
    worksheet.addRow([this.orderLblText.contactEmailLbl + ": " + this.userEmail + '', '', '', '', this.orderLblText.trackingMethodLbl + ": "]);
    worksheet.addRow([this.orderLblText.ccEmailLbl + ": " + (this.orderHeaderGridData.ccEmail ? this.orderHeaderGridData.ccEmail : '') + '', '', '', '', this.orderLblText.trackingNumberLbl + ": " ]);

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.columns[0].width = 25;
    let orderDetailsRow = worksheet.addRow(["Sample Product Order Details List"]);
    orderDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    dataArray.map(p =>
    ([
      p.stockNum ? p.stockNum : '',
      p.subCategoryDescription ? p.subCategoryDescription : '',
      p.quantity ? p.quantity : '',
      p.cost ? this.cp.transform(p.cost, 'USD', true, '1.2-2') : '',
    ])
    )
      .forEach(d => {
        let row = worksheet.addRow(d);
      });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'SampleProductOrderDetails.xlsx');
    })
    this.loadingExcel = false;
  }
  async generatePDF() { }
  //async generatePDF() {
  //  this.loadingPDF = true;
  //  var currFilter = this.orderGridSettings.state.filter;
  //  var filterData = process(this.orderGridData, {
  //    filter: currFilter
  //  });
  //  //#region - format data based on column settings
  //  var titleOutput = [];
  //  var fieldOutput = [];
  //  var widthOutput = [];
  //  this.orderGridSettings.columnsConfig.filter(c => c.hidden != true && c.widthForPDF > 0).forEach(c => {
  //    titleOutput.push(c.title);
  //    fieldOutput.push(c.field);
  //    widthOutput.push(c.widthForPDF);
  //  });
  //  var dataArray: any[] = [];
  //  filterData.data.forEach(d => {
  //    dataArray.push(_.pick(d, fieldOutput));
  //  });
  //  //#endregion
  //  var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
  //  let docDefinition = {
  //    header: {
  //      columns: [
  //        { text: todaysDate, margin: [10, 12, 10, 20] },
  //        { text: this.orderDetailsLblText.sampleProductLbl, alignment: 'center', margin: [10, 12, 0, 20] }
  //      ]
  //    },
  //    content: [
  //      {
  //        // under NodeJS (or in case you use virtual file system provided by pdfmake)
  //        // you can also pass file names here
  //        image: await this.commonService.getBase64ImageFromURL(
  //          location.origin.toString() + "/assets/images/kawneer_logo.JPG"
  //        ),
  //        alignment: 'center', fit: [150, 150]
  //      },        
  //      {
  //        columns: [
  //          [{
  //            text: this.orderLblText.sampleProductOrderNumberLbl + ": " + this.orderHeaderGridData.sampleProductOrderNumber,
  //            bold: true,
  //            margin: [0, 2, 0, 2]
  //          }, {
  //              text: this.orderLblText.customerLbl + ": " + this.orderHeaderGridData.customer,
  //              bold: true,
  //              margin: [0, 2, 0, 2]
  //            }, {
  //              text: this.orderLblText.contactLbl + ": " + this.orderHeaderGridData.contact,
  //              bold: true,
  //              margin: [0, 2, 0, 2]
  //            }, {
  //              text: this.orderLblText.contactEmailLbl + ": " + this.userEmail,
  //              bold: true,
  //              margin: [0, 2, 0, 2]
  //            }, {
  //              text: this.orderLblText.ccEmailLbl + ": " + (this.orderHeaderGridData.ccEmail ? this.orderHeaderGridData.ccEmail : ''),
  //              bold: true,
  //              margin: [0, 2, 0, 2]
  //            }
  //          ],
  //           [{
  //              text: this.orderLblText.createdDateLbl + ": " + this.orderHeaderGridData.createdDateUIString,
  //            bold: true,
  //            margin: [0, 2, 0, 2]
  //           }, {
  //               text: this.orderLblText.costLbl + ": " + (this.orderHeaderGridData.cost ? this.cp.transform(this.orderHeaderGridData.cost, 'USD', true, '1.2-2') : ''),
  //               bold: true,
  //               margin: [0, 2, 0, 2]
  //             }, {
  //               text: this.orderLblText.regionLbl + ": " + this.orderHeaderGridData.region,
  //               bold: true,
  //               margin: [0, 2, 0, 2]
  //             }, {
  //               text: this.orderLblText.trackingMethodLbl + ": " ,
  //               bold: true,
  //               margin: [0, 2, 0, 2]
  //             },
  //             {
  //               text: this.orderLblText.trackingNumberLbl + ": ",
  //               bold: true,
  //               margin: [0, 2, 0, 2]
  //             }
  //          ],
  //        ]
  //      },
  //      {
  //        text: "Sample Product Order Details List",
  //        style: 'sectionHeader'
  //      },
  //      {
  //        style: 'tableStyle',
  //        table: {
  //          headerRows: 1,
  //          //widths: ['*'],
  //          widths: widthOutput,
  //          body: [
  //            [
  //              this.orderDetailsLblText.stockNumLbl,
  //              this.orderDetailsLblText.productDescriptionLbl,
  //              this.orderDetailsLblText.quantityLbl,
  //              this.orderDetailsLblText.costLbl
  //            ],
  //            ...dataArray.map(p =>
  //            ([
  //              p.stockNum ? p.stockNum : '',
  //              p.subCategoryDescription ? p.subCategoryDescription : '',
  //              p.quantity ? p.quantity : '',
  //              p.cost ? this.cp.transform(p.cost, 'USD', true, '1.2-2') : '',
  //            ])
  //            )
  //          ]
  //        }
  //      }
  //    ],
  //    footer: {
  //      columns: [
  //        { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
  //      ]
  //    },
  //    styles: {
  //      headerLeft: {
  //        fontSize: 22,
  //      },
  //      headerRight: {
  //        fontSize: 22,
  //        alignment: 'center'
  //      },
  //      anotherStyle: {
  //        italics: true,
  //        alignment: 'right'
  //      },
  //      sectionHeader: {
  //        bold: true,
  //        decoration: 'underline',
  //        fontSize: 14,
  //        margin: [0, 15, 0, 15]
  //      },
  //      tableStyle: {
  //        fontSize: 8
  //      }
  //    }
  //  };

  //  pdfMake.createPdf(docDefinition).download('SampleProductOrderDetails.pdf');
  //  this.loadingPDF = false;
  //}


  redirectToOrderHistoryPage() {
    this.router.navigate(['sample-request-admin/sample-request-order-history']);
  }
}
